import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useUpdateMainEvent = () => {
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;
  const toast = useToast();

  return useMutation(
    async ({ eventId, fightId, isMainEvent }) => {
      const token = await getAccessTokenSilently();

      const response = await axios.put(
        `${apiUrl}/api/events/update-main-event/${eventId}/${fightId}`,
        { isMainEvent },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    },
    {
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to update main event status.";
        toast.error(errorMessage);
        console.error(
          "Error updating main event status:",
          error.response ? error.response.data : error
        );
      },
    }
  );
};
